import { dateFormat } from '@constants/dateFormat'
import moment from 'moment'
import queryString from 'query-string'
import type { Location } from 'react-router-dom'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import type { DateControlOptions, SupplyDirectoryQueryFilters } from '../types'
import type { StatusRowValue } from './types'

dayjs.extend(utc)

export const emptyResponse = (resp) => {
  return !resp.data || resp.data.pricing_row_count === 0
}

export const getDateFromFilters = (dateControl: DateControlOptions, asOf: string) =>
  dateControl === 'Now' ? dayjs().utc().toISOString() : asOf

export function getDefaultDate(currentDateFilter: DateControlOptions, date: string, time: string) {
  if (currentDateFilter === 'Now') {
    return { as_of: dayjs.utc().toISOString(), date_control: 'Now' }
  }
  const newDate = dayjs(`${date} ${time}`).utc().toISOString()
  return { as_of: newDate, date_control: 'Specific' }
}
export const createDateDefaults = (dateControl: DateControlOptions) => {
  const now = dayjs()
  const currentDate = now.format(dateFormat.YEAR_MONTH_DATE)
  const currentTime = now.format(dateFormat.TIME24)
  return getDefaultDate(dateControl, currentDate, currentTime)
}
export const getInitialQueryFilters = (location: Location, dateControl: DateControlOptions = 'Now') => {
  const dateDefaults = createDateDefaults(dateControl)
  const urlParams = queryString.parse(location.search)

  return {
    as_of: dateDefaults.as_of,
    ...urlParams,
  } as SupplyDirectoryQueryFilters['filter']
}

export function prefillOutageFormWithRowInformation(rowData: StatusRowValue) {
  return {
    terminal_id: rowData.terminal_id,
    terminal_name: rowData.terminal,
    product_id: rowData.product_id,
    product_name: rowData.product,
    product_group: rowData.product_group,
    supplier_id: rowData.supplier_id,
    supplier_name: rowData.supplier,
    price_type: rowData.price_type,
    contract: rowData.contract,
    supply_owner_id: rowData.counterparty_id,
    supply_owner_name: rowData.counterparty,
    schedule_local: {
      schedule_type: 'event',
      start_date: moment().format(),
    },
  } as Gravitate.SupplyOutage<Gravitate.EventSchedule>
}
